import {Controller} from '@hotwired/stimulus';
import {get} from '@rails/request.js';

export default class extends Controller {
  static targets = [
    'scaAfterSubmitClientSecret',
    'container',
    'stripeFormError'
  ];

  static values = {
    stripeKey: String,
    payPath: String
  }

  scaAfterSubmitClientSecretTargetConnected(target) {
    const clientSecret = target.value;
    target.remove();
    this.handleScaAfterSubmit(clientSecret);
  }

  handleScaAfterSubmit(clientSecret) {
    if (!clientSecret) {
      return;
    }

    this.containerTarget.ariaBusy = true;

    window.stripe = window.stripe || Stripe(this.stripeKeyValue);
    window.stripe.handleCardAction(clientSecret)
      .then((result) => {
        if (result.error) {
          throw new Error(result.error.message);
        } else {
          /* Refetch */
          const url = new URL(this.payPathValue, window.location.origin);
          url.searchParams.set('payment_intent_id', result.paymentIntent.id);
          return get(url.toString());
        }
      })
      .then(() => {
        this.containerTarget.ariaBusy = false;
      })
      .catch((error) => {
        this.stripeFormErrorTarget.textContent = error.message;
        this.containerTarget.ariaBusy = false;
      });
  }
}
